import { Icon, Link, Stack } from '@qbe/ads-core';
import React from 'react';

const StarIcon = () => (
  <Icon domain="custom" size={45} sx={{ fill: 'grey' }}>
    <svg viewBox="4.0 5.0 42.0 40.0" color="blue">
      <path d="M25 6.212c-.072 0-.169.024-.203.094L18.81 18.411 5.416 20.354c-.088.013-.16.077-.188.169-.03.093-.005.198.064.265l9.681 9.415-2.285 13.288c-.016.097.022.196.097.254.065.049.155.057.233.017L25 37.476l11.985 6.287c.07.037.167.03.235-.02.07-.056.108-.155.092-.25l-2.285-13.29 9.681-9.415c.07-.067.094-.172.064-.266-.028-.09-.1-.155-.186-.167L31.19 18.41 25.203 6.307c-.034-.07-.131-.095-.203-.095M12.913 45c-.302 0-.603-.097-.858-.287-.443-.337-.657-.881-.563-1.427l2.176-12.659-9.224-8.97c-.398-.39-.543-.962-.376-1.497.171-.542.62-.926 1.175-1.006l12.76-1.85L23.71 5.77C23.942 5.296 24.437 5 25 5s1.058.296 1.291.772l5.705 11.531 12.763 1.852c.552.079 1.002.463 1.173 1.004.167.536.022 1.108-.376 1.497l-9.224 8.971 2.176 12.66c.094.545-.12 1.089-.557 1.422-.44.33-1.056.377-1.53.127L25 38.846l-11.42 5.99c-.212.11-.44.164-.667.164" />
    </svg>
  </Icon>
);

export const StarsLink = ({ link }: { link: string }) => (
  <Link href={link} target="_blank" rel="noopener noreferrer">
    <Stack direction="row" gap="10px">
      <StarIcon />
      <StarIcon />
      <StarIcon />
      <StarIcon />
      <StarIcon />
    </Stack>
  </Link>
);
